<app-header></app-header>
<app-step></app-step>
<router-outlet></router-outlet>